import React, { Fragment, useEffect, useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";
import Modal from "react-modal";
import ReactToPrint from "react-to-print";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Editor from "@component/UI/TMEditor";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const { site, iam } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [abstract, setAbstract] = useState([]);
    const [registration, setRegistration] = useState(null);
    const [receipt, setReceipt] = useState(false);
    const [registrationConfirmation, setRegistrationConfirmation] = useState(false);
    const [abstractConfirmation, setAbstractConfirmation] = useState(null);
    const [registrationConfirmationTemplate, setRegistrationConfirmationTemplate] = useState(null);
    const [abstractConfirmationTemplate, setAbstractConfirmationTemplate] = useState(null);
    const [isRegistrationConfirmation, setIsRegistrationConfirmation] = useState(false);
    const [isAbstractConfirmation, setIsAbstractConfirmation] = useState(false);
    const [memos, setMemos] = useState([]);
    const [invitation, setInvitation] = useState(false);
    const [isInvitation, setIsInvitation] = useState(false);
    const [invitationTemplate, setInvitationTemplate] = useState(null);
    const [registrationConfig, setRegistrationConfig] = useState(null);
    const [abstractConfig, setAbstractConfig] = useState(null);

    const loadData = () => {
        _API.get({ path: "/site/mypage" })
            .then((res) => {
                const { registration, abstract, isInvitation, invitationTemplate, registrationConfirmationTemplate, abstractConfirmationTemplate, isRegistrationConfirmation, isAbstractConfirmation } = res.data;
                setAbstract(abstract);
                setRegistration(registration);
                setIsInvitation(isInvitation);
                setInvitationTemplate(invitationTemplate);
                setRegistrationConfirmationTemplate(registrationConfirmationTemplate);
                setAbstractConfirmationTemplate(abstractConfirmationTemplate);
                setIsRegistrationConfirmation(isRegistrationConfirmation);
                setIsAbstractConfirmation(isAbstractConfirmation);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    const loadConfig = () => {
        _API.get({ path: "/site/registration/config" })
            .then((res) => {
                const { cfg, memos } = res.data;
                setRegistrationConfig(cfg);
                setMemos(memos);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    const loadAbstractConfig = () => {
        _API.get({ path: "/site/abstract/config" })
            .then((res) => {
                const { cfg } = res.data;
                setAbstractConfig(cfg);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadData();
            if (iam) {
                if (site?.isUseRegistration === "Y") {
                    loadConfig();
                }
                if (site?.isUseAbstract === "Y") {
                    loadAbstractConfig();
                }
            }
        }
    }, [site?.siteCode, iam]);

    const getMemo = (type, field) => {
        let memo = memos.find((m) => m.type === type);

        if (!memo?.[field]) {
            return "";
        }
        if (field === "title") {
            return memo?.[field];
        } else {
            return <p dangerouslySetInnerHTML={{ __html: memo?.[field]?.replace(/\\/g, "") }}></p>;
        }
    };

    const onReceipt = () => {
        setReceipt(true);
    };

    const onConfirmation = () => {
        setRegistrationConfirmation(true);
    }

    const onAbstractConfirmation = (data) => {
        setAbstractConfirmation(data);
    }

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {site?.naviMypage && parse(site?.naviMypage)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Personal Information</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Personal Information</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <div className="boxTable">
                            <table className="tbl_mypage">
                                <thead>
                                    <tr>
                                        <th width="33.33%">Category</th>
                                        <th width="33.33%">Review &amp; Modify</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Personal Information</td>
                                        <td>
                                            <a href="/mypage/infor" className="btn_red2">
                                                Click Here
                                            </a>
                                        </td>
                                        <td>Completed</td>
                                    </tr>
                                    {site?.isUseAbstract === "Y" && (
                                        <tr>
                                            <td>Submission</td>
                                            <td className="ab_mypage1">
                                                {abstract?.map((item, index) => (
                                                    <p key={index} className="ab_list">
                                                        <a href={`/mypage/abstract/${item.idx}`}>
                                                            <u>{item.abstractNo}</u>
                                                        </a>
                                                    </p>
                                                ))}


                                                <p className="ab_newbtn">
                                                    {abstractConfig?.isUseAbstractButton === "Y" && (
                                                        <a href="/abstract/regist" className="btn_red2 mt5">
                                                            New Submission
                                                        </a>
                                                    )}
                                                </p>

                                            </td>
                                            <td className="ab_mypage1">
                                                {abstract?.map((item, index) => (
                                                    <p key={index} className="ab_list" >{_DEF.getDefinedLabel(_DEF.ABSTRACT_STATUS, item.status)}


                                                        {isAbstractConfirmation && item.finalStatus === 'Y' && (
                                                            <a href="" onClick={() => onAbstractConfirmation(item)} className="btn-abs-letter" style={{ marginLeft: "5px" }}>
                                                                Acceptance Letter
                                                            </a>
                                                        )}
                                                    </p>
                                                ))}
                                                <p className="ab_newbtn">
                                                    {abstractConfig?.isUseAbstractButton === "Y" && (
                                                        <>
                                                            -
                                                        </>
                                                    )}
                                                </p>
                                            </td>
                                        </tr>
                                    )}
                                    {site?.isUseRegistration === "Y" && (
                                        <tr>
                                            <td>Registration</td>
                                            <td>
                                                {registration ? (
                                                    <p>
                                                        <a href="/mypage/registration">{registration?.registrationNo}</a>
                                                    </p>
                                                ) : (
                                                    <>
                                                        {registrationConfig?.isUseRegistButton === "Y" && (
                                                            <span>
                                                                <a href="/registration/regist" className="btn_red2">
                                                                    Go to Online Registration
                                                                </a>
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                {registration ? (
                                                    <>
                                                        {_DEF.getDefinedLabel(_DEF.PAYMENT_STATUS, registration.payStatus)}
                                                        {registration.payStatus === "Y" && (
                                                            <div style={{ marginTop: "5px" }}>
                                                                <a href="" onClick={onReceipt} className="btn_arr2">
                                                                    {getMemo("RECEIPT", "title") || "Receipt"}
                                                                </a>

                                                                {isRegistrationConfirmation && (
                                                                    <a href="" onClick={onConfirmation} className="btn-regist-letter" style={{ marginLeft: "5px" }}>
                                                                        Registration Confirmation
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {isInvitation && registration && registration.regStatus === "Y" && (
                            <div className="invitationButtonArea">
                                <button onClick={() => setInvitation(true)} className="btn_arr2">Invitation</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {receipt && <RegistrationReceipt onClose={() => setReceipt(false)} />}
            {invitation && <Invitation registration={registration} data={invitationTemplate} onClose={() => setInvitation(false)} />}
            {registrationConfirmation && <RegistrationConfirmation data={registrationConfirmationTemplate} registration={registration} onClose={() => setRegistrationConfirmation(false)} />}
            {abstractConfirmation && <AbstractConfirmation data={abstractConfirmationTemplate} abstract={abstractConfirmation} onClose={() => setAbstractConfirmation(null)} />}
        </Fragment>
    );
};

export const RegistrationConfirmation = (props) => {
    const { iam } = useContext(AppContext);

    const [template, setTemplate] = useState(null);
    const printRef = useRef(null);

    const modalStyles = {
        overlay: {
            zIndex: "1001",
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "-45%",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
        },
    };

    const onMakeTemplate = () => {
        const tmp = JSON.parse(JSON.stringify(props.data));
        let content = tmp.content;
        content = content.replace("__NAME__", `${iam?.nameFirst} ${iam?.nameLast}`);
        content = content.replace("__DATE__", moment().format("MMMM D, YYYY").toUpperCase());
        content = content.replace("__TITLE__", iam?.metadata?.title);
        content = content.replace("__COMPANY__", iam?.metadata?.organ);
        content = content.replace("__ORGAN__", iam?.metadata?.organ);
        content = content.replace("__EMAIL__", iam?.id);
        content = content.replace("__COUNTRY__", _DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country));
        content = content.replace("__REGISTRATION_NO__", props.registration?.registrationNo);
        setTemplate(content);
    };

    useEffect(() => {
        if (iam) {
            onMakeTemplate();
        }
    }, [iam, props.data]);


    return (
        <Modal isOpen={true} onRequestClose={props.onClose} style={modalStyles} contentLabel="Registration Confirmation">
            <div dangerouslySetInnerHTML={{ __html: template }} ref={printRef}></div>
            <div className="btnArea1">
                <button className="btn1 btnGray1 mr2" onClick={props.onClose}>
                    Close
                </button>
                <ReactToPrint pageStyle={`
        @media print {
            * {
                overflow: visible !important;
                height: auto !important;
            }
        }
    `} trigger={() => <button className="btn1 btnBlue1">Print</button>} content={() => printRef.current} />
            </div>
        </Modal>
    );
};

export const AbstractConfirmation = (props) => {

    const { iam } = useContext(AppContext);

    const [template, setTemplate] = useState(null);
    const printRef = useRef(null);

    const modalStyles = {
        overlay: {
            zIndex: "1001",
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "-45%",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
        },
    };

    const onMakeTemplate = () => {
        const tmp = JSON.parse(JSON.stringify(props.data));
        console.log("props.abstract", props.abstract)
        let content = tmp.content;
        content = content.replace("__NAME__", `${iam?.nameFirst} ${iam?.nameLast}`);
        content = content.replace("__DATE__", moment().format("MMMM D, YYYY").toUpperCase());
        content = content.replace("__TITLE__", iam?.metadata?.title);
        content = content.replace("__COMPANY__", iam?.metadata?.organ);
        content = content.replace("__ORGAN__", iam?.metadata?.organ);
        content = content.replace("__EMAIL__", iam?.id);
        content = content.replace("__COUNTRY__", _DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country));
        content = content.replace("__ABSTRACT_NO__", props.abstract?.finalAbstractNo);
        setTemplate(content);
    };

    useEffect(() => {
        if (iam) {
            onMakeTemplate();
        }
    }, [iam, props.data]);

    return (
        <Modal isOpen={true} onRequestClose={props.onClose} style={modalStyles} contentLabel="Abstract Confirmation">
            <div dangerouslySetInnerHTML={{ __html: template }} ref={printRef}></div>
            <div className="btnArea1">
                <button className="btn1 btnGray1 mr2" onClick={props.onClose}>
                    Close
                </button>
                <ReactToPrint pageStyle={`
        @media print {
            * {
                overflow: visible !important;
                height: auto !important;
            }
        }
    `} trigger={() => <button className="btn1 btnBlue1">Print</button>} content={() => printRef.current} />
            </div>
        </Modal>
    );
};

export const RegistrationReceipt = (props) => {
    const { site, iam } = useContext(AppContext);
    const modalStyles = {
        overlay: {
            zIndex: "1001",
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "-45%",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
        },
    };
    const [cfg, setCfg] = useState(null);
    const [options, setOptions] = useState(null);
    const [data, setData] = useState({});
    const [program, setProgram] = useState([]);
    const [receiptTemplate, setReceiptTemplate] = useState(null);
    const [template, setTemplate] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const printRef = useRef(null);

    const loadConfig = () => {
        _API.get({ path: "/site/registration/config" })
            .then((res) => {
                const { cfg, options, memos, amounts, reg, receiptTemplate } = res.data;

                setCfg(cfg);
                setOptions(options);
                setData({
                    ...reg,
                    paymentDeadline: moment().add("weeks", 2).format("YYYY-MM-DD"),
                    senderName: reg?.senderName || `${iam?.nameFirst} ${iam?.nameLast} (${reg?.registrationNo})`,
                    country: _DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country),
                });
                if (reg?.program && reg?.program?.length > 0) {
                    setProgram(reg?.program);
                }
                setReceiptTemplate(receiptTemplate);
                setIsLoading(false);
            })
            .catch((e) => {
                console.log(e);
                _API.alert({ message: e.message || JSON.stringify(e) });
            });
    };

    useEffect(() => {
        if (site?.siteCode && iam) {
            loadConfig();
        }
    }, [site?.siteCode, iam]);

    const getProgramPrice = (item) => {
        let price = 0;
        if (data?.amountType === "SUPER") {
            price = iam?.country === "KR" ? item.superWonAmount : item.superUsdAmount;
        }
        if (data?.amountType === "EARLY") {
            price = iam?.country === "KR" ? item.earlyWonAmount : item.earlyUsdAmount;
        }
        if (data?.amountType === "PRE") {
            price = iam?.country === "KR" ? item.preWonAmount : item.preUsdAmount;
        }
        if (data?.amountType === "LATE") {
            price = iam?.country === "KR" ? item.lateWonAmount : item.lateUsdAmount;
        }

        return price || 0;
    };

    const getProgramStatus = (item) => {
        if (data?.program && data?.program?.length > 0) {
            const select = data?.program?.find((p) => p.programIdx === item.idx);
            return select?.value;
        }

        return "N";
    };

    useEffect(() => {
        if (!receiptTemplate) {
            return;
        }

        const tmp = JSON.parse(JSON.stringify(receiptTemplate));
        let content = tmp.content;

        content = content.replace("__REGISTRATION_NO__", data?.registrationNo);
        content = content.replace("__NAME__", `${iam?.nameFirst} ${iam?.nameLast}`);
        content = content.replace("__ORGAN__", `${iam?.metadata?.organ || ""}`);
        content = content.replace("__EMAIL__", `${iam?.email || iam?.id || ""}`);
        content = content.replace("__CATEGORY_NAME__", `${data?.categoryName}`);
        content = content.replace("__ADDRESS__", `${iam?.metadata?.address || ""}`);
        content = content.replace("__CURRENCY__", `${data?.country !== "KR" ? `USD ` : ""} ${data?.country === "KR" ? ` 원` : ""}`);
        content = content.replaceAll("__COUNTRY__", `${_DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country)}`);
        if (data?.amountType === "EARLY") {
            content = content.replace("__CATEGORY__", `Early Registration - ${data?.categoryName}`);
        } else if (data?.amountType === "PRE") {
            content = content.replace("__CATEGORY__", `Regular Registration - ${data?.categoryName}`);
        } else if (data?.amountType === "LATE") {
            content = content.replace("__CATEGORY__", `On-site Registration - ${data?.categoryName}`);
        } else if (data?.amountType === "SUPER") {
            content = content.replace("__CATEGORY__", `Super Early Registration - ${data?.categoryName}`);
        }

        content = content.replace("__CATEGORY_PRICE__", `${iam?.country !== "KR" ? `USD ` : ""} ${_U.addComma(data?.amount)} ${iam?.country === "KR" ? ` 원` : ""}`);
        content = content.replace("__TOTAL_PRICE__", `${iam?.country !== "KR" ? `USD ` : ""} ${_U.addComma(data?.totalAmount)} ${iam?.country === "KR" ? ` 원` : ""}`);

        let programHtml = "";
        for (let i in options) {
            const o = options[i];
            if (getProgramStatus(o) === "Y") {
                programHtml += `<tr>
                    <td class="payment1" colspan="3">${o.title}</td>
                    <td class="payment2">1</td>
                    <td class="payment3">${iam?.country !== "KR" ? `USD ` : ""} ${_U.addComma(getProgramPrice(o))}  ${iam?.country === "KR" ? ` 원` : ""}</td>
                </tr>`;
            }
        }
        content = content.replace("__OPTIONS_PROGRAM__", programHtml);
        content = content.replace("__PAYMENT_DATE__", data?.paymentDate ? moment(data?.paymentDate).locale("en").format("MMMM DD, YYYY") : "");
        content = content.replace("__PAYMENT_TYPE__", data?.payType === "CARD" ? `Credit Card` : `Wire Transfer`);
        content = content.replace("__DATE__", moment().locale("en").format("MMMM DD, YYYY"));
        content = content.replace("__CARD_AUTH__", data?.paymentPostdata?.cardauthcode || "");


        tmp.content = content;
        setTemplate(tmp);
    }, [receiptTemplate, data, options, iam]);

    return (
        <Modal isOpen={true} onRequestClose={props.onClose} style={modalStyles} contentLabel="Receipt">
            {isLoading && <Loading />}
            <div dangerouslySetInnerHTML={{ __html: template?.content }} ref={printRef}></div>
            <div className="btnArea1">
                <button className="btn1 btnGray1 mr2" onClick={props.onClose}>
                    Close
                </button>
                <ReactToPrint trigger={() => <button className="btn1 btnBlue1">Print</button>} content={() => printRef.current} />
            </div>
        </Modal>
    );
};

export const Invitation = (props) => {
    const { site, iam } = useContext(AppContext);
    const [template, setTemplate] = useState(null);
    const printRef = useRef(null);

    const modalStyles = {
        overlay: {
            zIndex: "1001",
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "-45%",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
        },
    };

    const onMakeTemplate = () => {
        const tmp = JSON.parse(JSON.stringify(props.data));
        let content = tmp.content;
        content = content.replace("__NAME__", `${iam?.nameFirst} ${iam?.nameLast}`);
        content = content.replace("__DATE__", moment().format("MMMM D, YYYY").toUpperCase());
        content = content.replace("__TITLE__", iam?.metadata?.title);
        content = content.replace("__COMPANY__", iam?.metadata?.organ);
        content = content.replace("__ORGAN__", iam?.metadata?.organ);
        content = content.replace("__EMAIL__", iam?.id);
        content = content.replace("__COUNTRY__", _DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country));
        content = content.replace("__REGISTRATION_NO__", props.registration?.registrationNo);
        setTemplate(content);
    };

    useEffect(() => {
        if (iam) {
            onMakeTemplate();
        }
    }, [iam, props.data]);


    return (
        <Modal isOpen={true} onRequestClose={props.onClose} style={modalStyles} contentLabel="Invitation">
            <div dangerouslySetInnerHTML={{ __html: template }} ref={printRef}></div>
            <div className="btnArea1">
                <button className="btn1 btnGray1 mr2" onClick={props.onClose}>
                    Close
                </button>
                <ReactToPrint pageStyle={`
        @media print {
            * {
                overflow: visible !important;
                height: auto !important;
            }
        }
    `} trigger={() => <button className="btn1 btnBlue1">Print</button>} content={() => printRef.current} />
            </div>
        </Modal>
    );
};